
<template>
  <div class="footer">
    <div id="disclaimer">
      © {{year}} eSecLending.  While eSecLending believes that the sources of the data provided for these reports to be reliable, it does not guarantee the accuracy of data shown. eSecLending does not attempt to reconcile data provided
      by third parties. This material is confidential and does not constitute legal, tax or investment advice.
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      year: new Date().getFullYear()
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color:#FAFAFA;
    z-index: 1;
    border-top: 1px solid #777;
    height: 58px;
    display: block;
    visibility: visible;
  }

  #disclaimer{
    text-align: center;
    font-size: 10.5px;
    color: #999;
    white-space:pre-wrap;
  }

</style>
